import Loader from "@components/global/Loader/Loader";
import { Provider } from "react-redux";
import {
  Action,
  AnyAction,
  applyMiddleware,
  combineReducers,
  createStore,
  Store,
} from "redux";
import { reducer as modals } from "redux-modal";
import {
  MigrationManifest,
  Persistor,
  persistReducer,
  persistStore,
} from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import createMigrate from "redux-persist/lib/createMigrate";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import storage from "redux-persist/lib/storage";
import thunk, { ThunkAction, ThunkDispatch } from "redux-thunk";
import activeRack from "./activeRack/reducer";
import activeRackItem from "./activeRackItem/reducer";
import * as authActions from "./auth/actions";
import { auth } from "./auth/reducer";
import availableRacks from "./availableLocationRacks/reducer";
import contracts from "./contracts/reducer";
import equipment from "./Equipments/reducer";
import filters from "./filters/reducer";
import globalNotifications from "./globalNotifications/reducer";
import locations from "./locations/reducer";
import me from "./me/reducer";
import migrations from "./migrations";
import minerChangeLogs from "./minerChangeLogs/reducer";
import minerProfiles from "./minerProfiles/reducer";
import { removeAllSelectedMiners } from "./minersSelect/actions";
import minersSelect from "./minersSelect/reducer";
import minersTable from "./minersTable/reducer";
import minerTypes from "./minerTypes/reduces";
import miningPlans from "./miningPlans/reducer";
import poolTemplates from "./poolTemplates/reducer";
import radiolabelsHistory from "./radiolabelHistory/reducer";
import radiolabels from "./radiolabels/reducer";
import savedMinerSettings from "./savedMinerSettings/reducer";
import socket from "./socket/reducer";
import storedMiners from "./storedMiners/reducer";
import timer from "./timer/reducer";
import unllacatedMiners from "./unallocatedMiners/reducer";
import users from "./users/reducer";

export const rootReducer_ = combineReducers({
  modals,
  auth,
  me,
  users,
  miningPlans,
  minerTypes,
  minersSelect,
  minersTable,
  locations,
  socket,
  unllacatedMiners,
  availableRacks,
  equipment,
  savedMinerSettings,
  minerChangeLogs,
  storedMiners,
  filters,
  activeRack,
  globalNotifications,
  contracts,
  minerProfiles,
  radiolabels,
  timer,
  activeRackItem,
  poolTemplates,
  radiolabelsHistory,
});

export const ROOT_CLEAR_ALL = "__ROOT_CLEAR_ALL_STATE__";

export const rootReducer: typeof rootReducer_ = (state, action) => {
  if (action.type === ROOT_CLEAR_ALL) {
    return rootReducer_(undefined, action);
  }
  return rootReducer_(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;
export type RootDispatch = ThunkDispatch<RootState, void, AnyAction>;

const persistConfig = {
  key: "WATTMAN:$6346fdg(9%9345-+dfgdfg5543)",
  storage,
  whitelist: ["auth", "minersTable", "savedMinerSettings", "timer"],
  version: 1,
  migrate: createMigrate(migrations as unknown as MigrationManifest, {
    debug: false,
  }),
  stateReconciler: autoMergeLevel2,
  // transforms: [startupConnectTransform],
};

let store: Store<RootState> | undefined = undefined;

export const getPersistor = () => {
  const persistedReducer = persistReducer<RootState>(
    persistConfig,
    rootReducer
  );
  store = createStore(
    persistedReducer,
    applyMiddleware<RootDispatch>(thunk)
  ) as Store<RootState>;
  const persistor: Persistor = persistStore(store);
  store.dispatch(authActions.init());
  store.dispatch(removeAllSelectedMiners());
  return { store, persistor };
};

export function initStore(App: () => JSX.Element) {
  const { store, persistor } = getPersistor();

  return (
    <Provider store={store}>
      <PersistGate loading={<Loader />} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  );
}

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

const store_ = () => store;
export default store_;
